import GenericTransition from '../../common/generic-transition'
import PACKAGE_COMPONENT_PREFIX from '../../common/config'

let single = new GenericTransition(PACKAGE_COMPONENT_PREFIX + 'zoom-in', 'zoomIn')
let group = new GenericTransition(PACKAGE_COMPONENT_PREFIX + 'group-zoom-in', 'zoomIn', undefined, true)

export default {single, group}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/zoom-entrances/zoom-in.js